// Guide editor profile content: the countries the guide works in, the interview, tips and gallery.
export const guideProfile = {
  countries: {
    label: "Countries the guide works in",
    help: "Only countries and places shown as a country. The first one is the guide's home destination in the guide schedule; the order follows your selection, and a newly added country goes last, so to make another country first, remove the countries in front of it and add them again.",
  },
  interview: {
    title: "We asked",
    empty: "No questions yet. Without questions the section does not appear on the website.",
    add: "Add question",
    itemN: "Question {{number}}",
    question: "Question",
    answer: "Answer",
    questionPlaceholder: "e.g. What do you enjoy most about guiding?",
    answerPlaceholder: "Plain text; separate paragraphs with an empty line",
  },
  tips: {
    title: "Tips",
    favoritePlace: "Favourite place or experience",
    food: "What to taste",
    advice: "Advice before the trip",
    favoritePlacePlaceholder: "e.g. Sunrise over the rice terraces in Sa Pa",
    foodPlaceholder: "e.g. Bún chả from a street stall in Hanoi",
    advicePlaceholder: "e.g. Pack a light raincoat even in the dry season",
  },
  gallery: {
    title: "Gallery",
  },
};
